const LEVELS = [
  { label: "surface-1", className: "bg-surface-1 ml-0" },
  { label: "surface-2", className: "bg-surface-2 ml-3" },
  { label: "surface-3", className: "bg-surface-3 ml-6" },
  { label: "surface-4", className: "bg-surface-4 ml-9" },
] as const;

export function SurfaceStack() {
  return (
    <div className="space-y-3">
      {LEVELS.map(lv => (
        <div
          key={lv.label}
          className={`rounded-lg border border-border px-4 py-3 ${lv.className}`}
        >
          <p className="font-mono text-[0.65rem] uppercase tracking-widest text-ink/90">
            {lv.label}
          </p>
          <p className="mt-1 text-sm text-ink-secondary">
            Elevação por tom — sem sombra pesada.
          </p>
        </div>
      ))}
    </div>
  );
}
